import React from "react";

const SlotsFake = () => {
  return (
    <>
      <section className="slots-fakes">
        <div className="slots-fakes--slot-container">
          <div className="skeleton slots-fakes--slot-container--slot" />
        </div>
        <div className="slots-fakes--slot-container right">
          <div className="skeleton slots-fakes--slot-container--slot" />
        </div>
        <div className="slots-fakes--slot-container">
          <div className="skeleton slots-fakes--slot-container--slot" />
        </div>
        <div className="slots-fakes--slot-container right">
          <div className="skeleton slots-fakes--slot-container--slot" />
        </div>
        <div className="slots-fakes--slot-container">
          <div className="skeleton slots-fakes--slot-container--slot" />
        </div>
        <div className="slots-fakes--slot-container right">
          <div className="skeleton slots-fakes--slot-container--slot" />
        </div>
      </section>
      <style jsx>{`
        .slots-fakes {
          display: flex;
          flex-wrap: wrap;
          margin-top: 1rem;
          justify-content: space-between;
          width: 100%;
          gap: 0.5rem;
          &--slot-container {
            width: 48%;
            height: 24px;
            box-sizing: border-box;
            display: flex;
            &--slot {
              height: 22px;
              width: 114px;
            }
          }
        }
        .right {
          display: flex;
          justify-content: end;
        }
      `}</style>
    </>
  );
};

export default SlotsFake;
